import Vue from 'vue';
import {mapActions, mapGetters} from 'vuex';
import { router } from '@src/routes';

import UIAdsBanner from './components/ads-banner/ads-banner.vue';
import UINoEventFound from '@components/ui-components/not-find-event/not-find-event.vue';
import UIViewButtons from './components/view-buttons/view-buttons.vue';
import UIFilter from '@components/ui-components/filter-container/filter-container.vue';
import UIEventsList from './components/events-list/events-list.vue';
import UIEventsCalendar from './components/events-calendar/events-calendar.vue';
import UIPopover from './components/popover/popover.vue';

import { CALENDAR_VIEW, LIST_VIEW, DEFAULT_VIEW } from './const';
import { getCookieValue } from "@src/libs/cookie"

export default {
	name: 'index',
	data() {
		return {
			template: '<main></main>',
			type: 'month',
			weekdays: [1,2,3,4,5,6,0],
			events: [],
			focus: '',
			eventClick: [],
			modalForm: null,
			adsBanner: null,
			currentView: null,
		}
	},
	components: {
		"ui-ads-banner": UIAdsBanner,
		"ui-no-event-found": UINoEventFound,
		"ui-view-buttons": UIViewButtons,
		"ui-filter": UIFilter,
		"ui-events-list": UIEventsList,
		"ui-events-calendar": UIEventsCalendar,
		"ui-popover": UIPopover,
	},
	computed: {
		isListView () {
			return this.currentView === LIST_VIEW
		},
		isCalendarView () {
			return this.currentView === CALENDAR_VIEW
		}
	},
	methods: {
		...mapActions('modal', ['modalType_regEventOpen', 'modalClose']),
		...mapActions('events', {
			getCalendarEvents: 'getCalendarEvents',
			getListEvents: 'getListEvents',
		}),
		setView (view) {
			if (view && this.currentView === view) return;

			this.currentView = view;

			this.$router.push({ query: { view }})
		},
		async getEvents (query) {
			switch (this.currentView) {
				case CALENDAR_VIEW:
					await this.getCalendarEvents(query);
					break;
				case LIST_VIEW:
					await this.getListEvents(query);
					break;
				default:
					break;
			}
		},
		buildEventQuery(q) {
			if (!this.isEmptyQuery(q)) return q

			const regionSlug = getCookieValue('regionSlug')

			if (regionSlug) return { region: regionSlug }
			else {
				console.error('Не удалось считать region')
				return q
			}
		},
		isEmptyQuery(q) {
			return Object.keys(q).length === 0
		}
	},
	async beforeRouteUpdate (to, _, next) {
		await this.getEvents(this.buildEventQuery(to.query))
		next();
	},
	async created() {
		// выставляем дефолтный вид (список / плитка)
		const view = this.$route.query.view;
		this.currentView = ![CALENDAR_VIEW, LIST_VIEW].includes(view)
			? DEFAULT_VIEW
			: view;

		// загружаем ивенты
		await this.getEvents(this.buildEventQuery(this.$route.query))
	},
	async beforeRouteEnter(to, _, next) {
		if (window.content) {
			next((vm) => {
				vm.template = window.content;
				window.content = undefined;
			});
			return;
		}

		const path = to.path.replace(router.history.base, '');

		try {
			const data = await Vue.http.get(`templates${path}`, { params: {} });

			next((vm) => vm.template = data.data);
		} catch ({ status }) {
			if (status === 403) {
				next({ name: 'E403' });
			}

			next({name: 'E404'});
		}
	},
	render(createElement) {
		return Vue.compile(this.template).render.call(this, createElement);
	},
};



// WEBPACK FOOTER //
// ./src/templates/pages/events/index.js